(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lookbook-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'img[data-lookbook-image]';
    const seen = new WeakSet();
    const queue = [];
    let active = 0;
    let ready = false;

    const loadImage = (image, priority) => new Promise((resolve) => {
      if (image.complete && image.naturalWidth > 0) {
        resolve();
        return;
      }
      const finish = () => {
        clearTimeout(timeout);
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        resolve();
      };
      const timeout = setTimeout(finish, 12000);
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
      if (image.fetchPriority !== 'high') image.fetchPriority = priority;
      image.loading = 'eager';
      if (image.complete) finish();
    });

    const pump = () => {
      if (!ready || document.hidden || navigator.connection?.saveData) return;
      while (active < 2 && queue.length) {
        const image = queue.shift();
        if (!image.isConnected || (image.complete && image.naturalWidth > 0)) continue;
        active += 1;
        loadImage(image, 'low').finally(() => {
          active -= 1;
          pump();
        });
      }
    };

    const collect = (root) => Array.from(root.querySelectorAll(selector)).filter((image) => {
      if (seen.has(image)) return false;
      seen.add(image);
      return true;
    });

    const start = () => {
      const images = collect(document);
      queue.push(...images.slice(3));
      Promise.all(images.slice(0, 3).map((image) => loadImage(image, 'auto'))).then(() => {
        const beginBackground = () => {
          ready = true;
          pump();
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(beginBackground, { timeout: 1000 });
        } else {
          setTimeout(beginBackground, 0);
        }
      });
    };

    document.addEventListener('visibilitychange', pump);
    document.addEventListener('shopify:section:load', (event) => {
      queue.push(...collect(event.target));
      pump();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
